import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavbarLeft from './navbarItem/NavbarLeft';
import NavbarRight from './navbarItem/NavbarRight';
import { HiOutlineMenuAlt3 } from 'react-icons/hi';
import { IoClose } from 'react-icons/io5';
import './navbar.css';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    document.body.classList.toggle('nav-drawer-open', isMobileMenuOpen);
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('nav-drawer-open');
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => setMobileMenuOpen((open) => !open);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <header className="main-nav">
      <div className="main-nav-inner">
        <NavbarLeft />

        <div className="main-nav-desktop">
          <NavbarRight />
        </div>

        <button
          type="button"
          className="main-nav-toggle"
          onClick={toggleMobileMenu}
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-navigation"
          aria-label={isMobileMenuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
        >
          {isMobileMenuOpen ? <IoClose /> : <HiOutlineMenuAlt3 />}
        </button>
      </div>

      <div
        className={`main-nav-backdrop${isMobileMenuOpen ? ' is-visible' : ''}`}
        onClick={closeMobileMenu}
        aria-hidden={!isMobileMenuOpen}
      />

      <aside
        id="mobile-navigation"
        className={`main-nav-drawer${isMobileMenuOpen ? ' is-open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <div className="main-nav-drawer-header">
          <span className="main-nav-drawer-title">Menü</span>
          <button
            type="button"
            className="main-nav-drawer-close"
            onClick={closeMobileMenu}
            aria-label="Menüyü kapat"
          >
            <IoClose />
          </button>
        </div>
        <NavbarRight mobile onNavigate={closeMobileMenu} />
      </aside>
    </header>
  );
};

export default Navbar;
